import store from "@/store"

export const state = () => ({
  list: [],
  count: 0,
  profile: {
    id: null,
    username: "",
    access_level: null,
    exp: null
  }
})

export const getters = {
  usersList: (state) => state.list || []
}

export const mutations = {
  createItem(state, payload) {
    state.list = [...state.list, payload]
  },
  updateItem(state, payload) {
    const findIndex = state.list.findIndex((item) => item.id === payload.id)
    if (findIndex !== -1) {
      state.list = [
        ...state.list.slice(0, findIndex),
        payload,
        ...state.list.slice(findIndex + 1)
      ]
    }
  },
  deleteItem(state, payload) {
    const findIndex = state.list.findIndex((item) => item.id === payload.id)
    if (findIndex !== -1) {
      state.list = [
        ...state.list.slice(0, findIndex),
        ...state.list.slice(findIndex + 1)
      ]
    }
  },

  setState(state, payload) {
    Object.keys(payload).forEach((item) => {
      if (item in state) {
        state[item] = payload[item]
      }
    })
  }
}

export const actions = {
  fetchList({ commit }, params) {
    return store.$api
      .get("/user/list", {
        params
      })
      .then((res) => {
        // console.log(res.data);
        commit("setState", {
          list: (res.data && res.data.results) || [],
          count: (res.data && res.data.items_count) || 0
        })

        return {
          data: (res && res.data && res.data.results) || [],
          count: (res && res.data && res.data.items_count) || 0
        }
      })
      .catch((err) => {
        console.error(err)
      })
  },

  detail: (_, payload) => store.$api.get("/user/detail/" + payload),

  submit(_, payload) {
    const req = {
      url: payload.id ? "/user/update/" + payload.id : "/user/create",
      method: payload.id ? "put" : "post"
    }

    return this.$api[req.method](req.url, payload)
      .then((res) => {
        // console.log(res);
        return res && res.data
      })
      .catch((err) => {
        console.error(err)
      })
  },
  deleteItemAction({ commit }, payload) {
    return this.$api
      .delete("/user/delete/" + payload)
      .then((res) => {
        console.log(res)
        commit("deleteItem", res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  },

  setAvatar(_, { userId, image }) {
    const f = new FormData()
    f.append("avatar", image)
    return this.$api.put("/user/setavatar/" + userId, f)
  }
}
